import {_} from 'lodash';
import * as ko from "knockout";
import {IFormTemplatePage} from "../../../../index";
import {ErrorTracker} from "../../../../error.tracker";
import {global} from "../../../../appContext";
import {nsForm} from "../../nsForm";
import ALL_PARTS = nsForm.ALL_PARTS;

export class PageData {
    public data: IFormTemplatePage;
    public id: number;
    public body: KnockoutObservable<string | null> = ko.observable(null);
    public description: KnockoutObservable<string | null> = ko.observable(null);
    private readonly et: ErrorTracker = global.errorAreas.get('form.template.mutable');

    constructor(page?: IFormTemplatePage) {
        this.data = page ?? {
            body: '',
            description: '',
            id: 0,
            order: 0,
        }
        this.data.body = this.whiteWashHtml(this.data.body);
        this.id = this.data.id;
        this.body(this.data.body);
        this.description(this.data.description);
    }

    public getSubmitData(): IFormTemplatePage {
        return _.defaults({
            body: this.whiteWashHtml(this.body() ?? ''),
            description: this.description() ?? '',
        }, this.data);
    }

    public isValid(hasInputField: boolean, duplicateIdentifiers: any): boolean {
        const a = this._isValidDescription();
        const b = this._isValidBody(hasInputField, duplicateIdentifiers);
        return a && b;
    }

    private _isValidDescription(): boolean {
        const a = !!this.description();
        this.et.update(!a, this.description, 'Ugyldig beskrivelse');
        return a;
    }

    private _isValidBody(hasInputField: boolean, duplicateIdentifiers: any): boolean {
        const div = document.createElement('div');
        div.innerHTML = this.body() ?? '';
        const b = !!div.textContent?.length;
        if (!b) {
            this.et.update(true, this.body, 'Ugyldig brødtekst');
            return false;
        }
        if (!hasInputField) {
            this.et.update(true, this.body, 'Mangler (minst ett) skjemafelt');
            return false;
        }
        const c = _.intersection(this.getIdentifiers(), duplicateIdentifiers);
        if (c.length) {
            this.et.update(true, this.body, 'Duplikat synkfelt id (+ attributt id)');
            return false;
        }

        const d = this.getIdentifiers().find(o => /[\[\]|;]/.test(o))
        if (d) {
            this.et.update(true, this.body, `Synkfelt id inneholder ulovlig tegn ('[', ']', '|', ';')`);
            return false;
        }

        this.et.update(false, this.body);
        return true;
    }

    public hasInputField(): boolean {
        return !!this.getInputFields().length;
    }

    public getFormParts(): IField[] {
        let ret = [];
        const body = this.body() ?? '';
        for (let i = 0; i < body.length; i++) {
            const f = nsForm.getRawFormPart(i, body);
            ret.push(f);
            i = f.end;
        }
        return ret;
    }

    public getInputFields(): IField[] {
        return this.getFormParts().filter(o => o.html && ALL_PARTS.find(p => o.html!.slice(1).startsWith(p)));
    }
    
    public getIdentifiers(): string[] {
        return this.getInputFields()
            .map(o => o.html!.slice(1, -1).split(';')[1])
            .filter((id): id is string => id !== undefined);
    }
    
    public getSyncfieldIds(): string[] {
        return this.getIdentifiers()
            .map(s => s.split('.')[0])
            .filter((id): id is string => id !== undefined);
    }

    private whiteWashHtml(html: string): string {
        return html.replace(/\sdata-mce-bogus="1"/gm, '')
    }

}